module.exports = __webpack_public_path__ + "img/ic-calendar.4bf46da9.svg";